import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import { getListYears } from '../../helper'
import { BLOCK_CONFIG, BLOCK_TYPE } from '../constants'
import { getDataAvailability, getReportItem } from './thunk'

const slice = createSlice({
  name: 'common/order/factSheet',
  initialState: {
    factSheetChecked: Object.values(BLOCK_TYPE).reduce(
      (obj, value) => ({
        ...obj,
        [value]: BLOCK_CONFIG[value].defaultChecked,
      }),
      {},
    ),
    fsType: false,
    sources: [],
    source: '',
    data: {},
    dataAvailabilityDetails: [],
    isLoading: true,
    isLoadingDataAvailable: true,
  },
  reducers: {
    changeFactSheetChecked: (state, action) => {
      state.factSheetChecked = { ...state.factSheetChecked, ...action.payload }
    },
    changeFsType: (state, action) => {
      state.fsType = action.payload
    },
    changeSource: (state, action) => {
      state.source = action.payload
    },
    resetStore: (state) => {
      state.isLoading = true
      state.isLoadingDataAvailable = true
      state.data = {}
      state.sources = []
      state.dataAvailabilityDetails = []
      state.source = {}
      state.fsType = false
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getReportItem.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getReportItem.fulfilled, (state, { payload = {} }) => {
      state.isLoading = false

      if (Object.keys(payload).length) {
        const { data = {}, sources = [] } = payload

        state.data = data

        state.sources = sources

        const listYears = getListYears(data.availableData)

        if (listYears.length) {
          state.data.availableData = listYears.join(', ')
        }
      }
    })
    builder.addCase(getReportItem.rejected, (state, action) => {
      state.isLoading = action.payload.isLoading
    })
    builder.addCase(getDataAvailability.pending, (state) => {
      state.isLoadingDataAvailable = true
    })
    builder.addCase(
      getDataAvailability.fulfilled,
      (state, { payload = [] }) => {
        state.isLoadingDataAvailable = false

        state.dataAvailabilityDetails = payload

        const lastData = payload[payload.length - 1]

        if (lastData) {
          const { sourceOrganizationId, consolidated } = lastData
          state.source = sourceOrganizationId
          state.fsType = consolidated
        }
      },
    )
    builder.addCase(getDataAvailability.rejected, (state, action) => {
      state.isLoadingDataAvailable = action.payload
    })
  },
})

export const selectFactSheetChecked = (state) =>
  state[slice.name].factSheetChecked
export const selectFsType = (state) => state[slice.name].fsType
export const selectSources = (state) => state[slice.name].sources
export const selectSource = (state) => state[slice.name].source
export const selectData = (state) => state[slice.name].data
export const selectIsLoading = (state) => state[slice.name].isLoading
export const selectIsLoadingDataAvailability = (state) =>
  state[slice.name].isLoadingDataAvailable
export const selectDataAvailabilityDetails = (state) =>
  state[slice.name].dataAvailabilityDetails

export const {
  changeFactSheetChecked,
  changeFsType,
  changeSource,
  resetStore,
} = slice.actions

register(slice.name, slice.reducer)
